import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";

const WebrtcDiagnosticsPage = Loadable(
  lazy(() =>
    import("./WebrtcDiagnostics").then(({ WebrtcDiagnostics }) => ({
      default: WebrtcDiagnostics,
    }))
  )
);

export const webrtcDiagnosticsRoutes = [
  {
    path: "/settings/webrtc-diagnostics",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <WebrtcDiagnosticsPage />
      </AuthorizedRoute>
    ),
  },
];
